import React from "react"
import { Query } from "@apollo/client/react/components"
import * as schemas from "./schemas"

export default ({ children }) => (
  <Query query={schemas.COUNTRIES}>
    {res => !res.loading && children(res.data.countries)}
  </Query>
)
